<template>
    <div id="app">
        <div class="app-links">
            <router-link :to="{ name: 'Hello' }">Aide</router-link>
            <router-link :to="{ name: 'Associate' }">Associate</router-link>
            <router-link to="/edit/1234">Edit</router-link>
        </div>
        <router-view/>
    </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style>
    .app-links {
        text-align: center;
    }

    .char-count {
      display: block;
      text-align: right;
    }

    h1 {
      font-size: 2rem;
    }
</style>




// WEBPACK FOOTER //
// src/App.vue